import React from 'react';
import Accordion from 'mui/components/elements/DS_Accordion';
import { StyledFaqWrapper, StyledInfoHeadline } from './DS_FaqListStyles';

const DS_FaqList = ({ faqs, headlineVariant, isRichText }) => {
  return (
    <StyledFaqWrapper>
      {faqs?.map((faq, index) => {
        if (faq.__typename === 'ContentfulElementAccordion')
          return (
            <Accordion
              key={`${faq.id}-${index}`}
              isRichTextValue={true}
              data={{
                label: faq.heading,
                value: faq.contentRt,
                isOpenedByDefault: faq.isOpenedByDefault,
              }}
            />
          );
        else if (faq.__typename === 'ContentfulElementInfo')
          return (
            <div key={`${faq.id}-${index}`}>
              {faq.bigText ? (
                <StyledInfoHeadline
                  component={isRichText ? 'h4' : headlineVariant === 'h1' ? 'h2' : 'h3'}
                  variant="DS_copyBigBold"
                >
                  {faq.bigText}
                </StyledInfoHeadline>
              ) : null}
            </div>
          );
      })}
    </StyledFaqWrapper>
  );
};

export default DS_FaqList;
